export default __webpack_public_path__ + "assets/images/f90ee8dc4d399489c124648d0589c8ba.svg";